import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import { withRouter } from 'react-router-dom';
import Iframe from 'react-iframe';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import ChatBox from '../../components/ChatBox'
import ChatBoxMobile from '../../components/ChatBoxMobile'
import withSizes from 'react-sizes';


class MainChatbot extends Component{

    state = {
        trimmedDataURL: null,
        uniqueId: localStorage.getItem('token'),
        windowHeight: undefined,
        windowWidth: undefined,
    }

    handleResize = () => {
        this.setState({
          windowHeight: window.innerHeight,
          windowWidth: window.innerWidth,
        });
        this.innerWidth = window.innerWidth;
        console.log(
          "Window Size: window.innerHeight: " +
            window.innerHeight +
            " window.innerWidth: " +
            window.innerWidth +
            " div 4: " +
            window.innerWidth / 4
        );
      };

      componentDidMount() {
        this.handleResize();
        window.addEventListener("resize", this.handleResize);
      }

      componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
      }
    

    render(){
        const { classes } = this.props;
        let { trimmedDataURL } = this.state;

        return(
            <div >
            {this.state.windowWidth > 1220 && <ChatBox lang={this.props.lang} style={{width:'100%'}} /> }
            {this.state.windowWidth <= 500 && <ChatBoxMobile lang={this.props.lang} style={{marginTop:'20px', width:'100%'}} /> }
            { (this.state.windowWidth <= 1220 && this.state.windowWidth > 500) && <ChatBoxMobile lang={this.props.lang} style={{width:'100%'}} /> }
            </div>  
        );
    }
}

const mapStateToProps = (state) => {
    return {
    isAuthenticated: state.auth.token !== null,
    //userId: state.auth.userId,
    lang: state.i18nState.lang,
    caseId: state.caseInfo.caseId,
    claimantUniqueId: state.caseInfo.claimantUniqueId,
    respondentUniqueId: state.caseInfo.respondentUniqueId,
    claimant_name: state.caseInfo.claimant_name,
    respondent_name: state.caseInfo.respondent_name,
    userType: state.caseInfo.userType,
    conversationId: state.caseInfo.conversationId,
    caseId: state.caseInfo.caseId,
    userType: state.caseInfo.userType,
    loadingCaseInfo: state.caseInfo.loading,
    loadingStepCompleted: state.onBoarding.loading,
    caseData: state.caseInfo.caseData,
    steps_completed: state.caseInfo[`${state.caseInfo.userType}_steps_completed`],
    newAccount:  state.caseInfo[`${state.caseInfo.userType}_newAccount`] ? state.caseInfo[`${state.caseInfo.userType}_newAccount`]/*['newAccount']*/ : null,
    }
  }

  const mapSizesToProps = sizes => ({
    isMobile: withSizes.isMobile(sizes),
    isTablet : withSizes.isTablet(sizes),
    isDesktop : withSizes.isDesktop(sizes),
    isGtMobile : withSizes.isGtMobile(sizes),
    isGtTablet : withSizes.isGtTablet(sizes),
    isStTablet : withSizes.isStTablet(sizes),
    isStDesktop : withSizes.isStDesktop(sizes),
    isTabletAndGreater : withSizes.isTabletAndGreater(sizes),
    isTabletAndSmaller : withSizes.isTabletAndSmaller(sizes),
  
  })
  
  const mapDispatchToProps = (dispatch) => {
    return {
      onLogout: () => dispatch(actions.logout()),
      onAuth: (username, password) => dispatch(actions.auth(username, password)),
      onBoardingStepCompletion: (uniqueId, caseId, userType, step_completed) => dispatch(actions.onBoardingStepCompletion(uniqueId, caseId, userType, step_completed)),
      getCaseInfo: (caseId, uniqueId) => dispatch(actions.getCaseInfo(caseId, uniqueId)),
      getUserInformation: (uniqueId) => dispatch(actions.getUserInformation(uniqueId)),
    }
  }

  MainChatbot.contextTypes = {
    t: PropTypes.func
}

// export default withStyles(styles)(MainChatbot);
export default withRouter(connect(mapStateToProps, mapDispatchToProps)((withSizes(mapSizesToProps)) ((MainChatbot))));
// export default withRouter(connect(mapStateToProps, mapDispatchToProps) (withSizes(mapSizesToProps) (MainChatbot)))